import { render, staticRenderFns } from "./inbound-outbound-add-product.vue?vue&type=template&id=8317dca0&scoped=true&"
import script from "./inbound-outbound-add-product.vue?vue&type=script&lang=js&"
export * from "./inbound-outbound-add-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8317dca0",
  null
  
)

export default component.exports